import { alpha, useTheme } from '@mui/material';
import { FC } from 'react';

import { ContainerInstanceButtonStyled } from './styles/CustomInstanceButtonStyles';
import useLogger from '../../../hooks/useLogger/useLogger';
import AtomButton from '../../atoms/AtomButton/AtomButton';
import InstanceLaunchIcon from '../../icons/svg/InstanceLaunchIcon';
import { styleConfigs } from '../../resources/styleConfigs';

interface ICustomInstanceButton {
  buttonText?: string;
  buttonLink?: string;
  hideIcon?: boolean;
  openInSameTab?: boolean;
  onBeforeNavigate?: () => void | Promise<void>;
}

export const CustomInstanceButton: FC<ICustomInstanceButton> = (props) => {
  const { buttonText, buttonLink, hideIcon, openInSameTab, onBeforeNavigate } = props;
  const theme = useTheme();
  const colorPalette = theme.palette.primary.main;
  const { operations: loggerOps } = useLogger();

  const handleGoInstanceLink = async (): Promise<void> => {
    if (!buttonLink) {
      return;
    }

    if (onBeforeNavigate) {
      try {
        await onBeforeNavigate();
      } catch (error: unknown) {
        loggerOps.writeLogger({
          project: 'front-end',
          source: 'CustomInstanceButton',
          func: 'handleGoInstanceLink',
          error: JSON.stringify(error),
          level: 'error',
        });
      }
    }

    if (openInSameTab) {
      window.location.href = buttonLink;
    } else {
      window.open(buttonLink, '_blank');
    }
  };

  return (
    <ContainerInstanceButtonStyled
      data-testid="sidebar-instance-button-container"
      data-cy="sidebar-instance-button-container"
    >
      <AtomButton
        data-testid="custom-instance-button-open"
        data-cy="custom-instance-button-open"
        data-cy-button-type="custom-instance"
        data-cy-has-link={!!buttonLink}
        variant="contained"
        onClick={handleGoInstanceLink}
        startIcon={
          hideIcon ? undefined : (
            <InstanceLaunchIcon data-testid="sidebar-instance-launch-icon" data-cy="sidebar-instance-launch-icon" />
          )
        }
        sx={{
          display: 'flex',
          fontWeight: styleConfigs.fonts.weight500,
          fontSize: styleConfigs.fonts.fontSize15,
          lineHeight: styleConfigs.fonts.lineHeight26,
          color: theme.palette.primary.contrastText,
          paddingBlock: styleConfigs.marginPadding.custom8rem,
          paddingInline: styleConfigs.marginPadding.custom22rem,
          gap: styleConfigs.marginPadding.custom8rem,
          borderRadius: styleConfigs.borders.radius50rem,
          '& .MuiButton-startIcon': {
            margin: styleConfigs.marginPadding.empty,
          },
          '&:hover': {
            backgroundColor: alpha(colorPalette, 0.9),
          },
        }}
      >
        {buttonText}
      </AtomButton>
    </ContainerInstanceButtonStyled>
  );
};
